import { combineReducers } from 'redux';
import { createCmsDuck } from 'helpers/cms';

export const STORE_KEY = 'globalPromo';
export const CMS_KEY = 'cms';

export const cmsDuck = createCmsDuck({
  page: 'global-promo',
  path: [STORE_KEY, CMS_KEY],
});

const reducer = combineReducers({
  cms: cmsDuck,
});

reducer.key = STORE_KEY;

export { reducer };
